import { lazy } from "react";

import { Route, Routes } from "react-router";
import PrivateRoute from "../common/middlewares/PrivateRoute";

//CASL
import { Can } from "../common/config/Can";

//Componentes
import Menu from "../common/pages/Main";
import Home from "../Pages/Home";
import Servicios from "../Pages/Servicios";
import AdminUsers from "../Pages/Admin"
import ErrorPage from "../common/components/Error";

const Perfil = lazy(() => import("../Pages/Perfil/Navegacion"));
const TrophyRoom = lazy(() => import("../Pages/Reconocimientos/Pages/TrophyRoom"));
const ApprovalInbox = lazy(() => import("../Pages/Reconocimientos/Pages/ApprovalInbox"));

const RoutesWilson = () => {
    return (
        <Routes>
            <Route element={<PrivateRoute />}>
                <Route path="/" element={<Menu />}>
                    <Route path="/inicio" exact element={<Home />} />
                    <Route path="/servicio" exact element={<Servicios />} />
                    <Route path="/sala-de-trofeos" exact element={<TrophyRoom />} />
                    <Route path="/perfil" exact element={<Perfil />} />
                    <Route path="/admin/users" exact element={
                        <Can I="view" a="Admin">
                            {(allowed) =>
                                allowed ? (
                                    <div style={{ width: "100%" }}>
                                        <AdminUsers />
                                    </div>
                                ) : (
                                    <ErrorPage
                                        title="401 Unauthorized"
                                        severity="error"
                                        msg="No tienes permisos para acceder a este sitio, comunícate con el área de TI para más información."
                                    />
                                )
                            }
                        </Can>
                    } />
                    <Route path="/admin/reconocimientos/aprobacion" exact element={
                        <Can I="view" a="Reconocimientos">
                            {(allowed) =>
                                allowed ? (
                                    <div style={{ width: "100%" }}>
                                        <ApprovalInbox />
                                    </div>
                                ) : (
                                    <ErrorPage
                                        title="401 Unauthorized"
                                        severity="error"
                                        msg="No tienes permisos para acceder a este sitio, comunícate con el área de TI para más información."
                                    />
                                )
                            }
                        </Can>
                    } />
                    <Route path="/perfil/edit/:strEmail/:strnombreCompleto" exact element={
                        <Can I="view" a="Admin">
                            {(allowed) =>
                                allowed ? (
                                    <div style={{ width: "100%" }}>
                                        <Perfil />
                                    </div>
                                ) : (
                                    <ErrorPage
                                        title="401 Unauthorized"
                                        severity="error"
                                        msg="No tienes permisos para acceder a este sitio, comunícate con el área de TI para más información."
                                    />
                                )
                            }
                        </Can>
                    } />
                </Route>
            </Route>
        </Routes>
    );
}

export default RoutesWilson;